{
  "Monitor": [
    "AmbientMonitor",
    "GroundWaterMonitor",
    "SoilMonitor",
    "SurfaceWeatherStation",
    "SurfaceWaterMonitor",
    "UpperAirWeatherStation",
    "VibrationMonitor",
    "NoiseMonitor",
    "DiscreteReceptor"
  ],
  "ProcessVariable": [
    "ProcessVariableRaw",
    "ProcessVariableAggregated",
    "ProcessVariableCtwa",
    "ProcessVariableCycleTimeAggregate",
    "ProcessVariableAnnotated",
    "ProcessVariableTimeDifference",
    "ProcessVariableFixedPeriod",
    "ProcessVariableFormula",
    "ProcessVariableHeatStress",
    "ProcessVariableInversion",
    "ProcessVariableWindSpeed",
    "ProcessVariableWindDirection",
    "ProcessVariableCloudCover",
    "ProcessVariableCloudHeight",
    "ProcessVariableLookedUp",
    "ProcessVariableOdourFingerprint",
    "ProcessVariablePeriodicAggregate",
    "ProcessVariablePredicted",
    "ProcessVariableRelativeToAbsoluteHumidity",
    "ProcessVariableWindGust",
    "ArrayProcessVariable",
    "ProcessVariableBandLimitedReducer",
    "ProcessVariableArrayReducer",
    "ProcessVariableTransformed",
    "ProcessVariableQldEhpValidatedAverage"
  ],
  "Process": [
    "SimpleProcess",
    "SourceAreaProcess",
    "AmbientMonitor",
    "GroundWaterMonitor",
    "SoilMonitor",
    "SurfaceWeatherStation",
    "SurfaceWaterMonitor",
    "UpperAirWeatherStation",
    "VibrationMonitor",
    "NoiseMonitor",
    "DiscreteReceptor"
  ],
  "ProcessSchema": [
    "NoiseProcessSchema",
    "WeatherProcessSchema",
    "Auxiliary2250ProcessSchema",
    "NoiseClassifierProcessSchema",
    "VibrationTofProcessSchema"
  ],
  "CalmetConfiguration": [
    "CalmetWithWrfConfiguration",
    "CalmetWithProcessDataConfiguration"
  ],
  "ReportDefinition": [
    "PowerBiReportDefinition",
    "GenericWebReportDefinition",
    "GenericJobReportDefinition",
    "LegacyReportDefinition"
  ],
  "Ticket": [
    "ObservationTicket"
  ],
  "AlertOutput": [
    "FtpAlertOutput",
    "TicketAlertOutput",
    "WebAlertOutput"
  ],
  "Sequence": [
    "ScheduledSequence",
    "ModellingSequence"
  ],
  "BaseAggregatedProcessVariable": [
    "ProcessVariableAggregated",
    "ProcessVariableCtwa",
    "ProcessVariableQldEhpValidatedAverage"
  ]
}